// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EN2ub{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.QMEY1{color:#202626;font-size:.875rem;font-weight:600}.IK4yK{align-self:flex-start;-webkit-box-ordinal-group:2;color:#747c7f;flex-shrink:0;height:28px;margin:5px 26px 0 0;order:1;width:22px}.tJ4Sy{height:35px;margin-right:21px;width:27px}.UgyI4{margin:0;-webkit-box-ordinal-group:unset;order:unset}.TBQo1{height:15px;width:12px}.TBQo1.tJ4Sy{height:18px;width:14px}.C3Aog{height:14px;width:11px}.C3Aog.tJ4Sy{height:18.5px;width:13.5px}.V87uj{color:#202626;margin-bottom:7px;margin-right:12px}.V87uj.tJ4Sy{margin-bottom:0;margin-right:7px}.JvZoX{color:#5d6466;grid-area:icon;margin:0}.QA3Lp{color:#747c7f;height:28px;width:22px}.yk84J{-webkit-box-ordinal-group:3;order:2}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EN2ub`,
	"root_instabookTripEditor": `QMEY1`,
	"icon": `IK4yK`,
	"icon_noCaptain": `tJ4Sy`,
	"icon_instabook": `UgyI4`,
	"icon_calendarCard": `TBQo1`,
	"icon_bookingCard": `C3Aog`,
	"icon_charterType": `V87uj`,
	"icon_instabookSummary": `JvZoX`,
	"icon_instabookTripEditor": `QA3Lp`,
	"content": `yk84J`
};
module.exports = ___CSS_LOADER_EXPORT___;
